import React, {Component} from 'react';

let WebNewsDataHandler = function(){

};

WebNewsDataHandler.prototype.isSupport = function(data){
    this.data = data;
    if(this.data.mediaId && this.data.id){
        return true;
    }
    return false;
};

WebNewsDataHandler.prototype.handle = function (call) {
    let object = {
        params : null,
        configName :"webStoryEditor",
        id : this.data.id,
    };
    call(object);
};

export default WebNewsDataHandler;